import React, { useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { map, uniqueId, isEmpty } from 'lodash';
import { addDotsEllipsis, ImageThumb } from 'utils/helpers';
import ArticleModal from 'common-components/modals/article-modal';

const AStylised = styled(Box)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.dark,
  transition: '.15s ease-in-out',
  '&:hover': {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
}));

const Focus = (props) => {
  const { t } = useTranslation();
  const { data, isLoading } = props;
  const [openModal, setOpenModal] = useState(false);
  const [focusData, setFocusData] = useState(null);

  const handleClose = () => {
    setOpenModal(false);
    setFocusData(null);
  };

  const clickHandle = (focus) => {
    setFocusData(focus);
    setOpenModal(true);
  };

  if (!isLoading && (!data || isEmpty(data.focusItems))) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h2">{t('Focus')}</Typography>
        {isLoading && <Skeleton height={100} />}
        {!isLoading && !isEmpty(data.focusItems) && (
          <Box mt={2}>
            {map(data.focusItems.slice(0, 4), (focus) => {
              return (
                <AStylised key={uniqueId('focus_')} onClick={() => clickHandle(focus)}>
                  <Grid container direction='row' mb={2}>
                    <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      <ImageThumb src={focus.imageLink} styles={{ maxWidth: '100%', paddingRight: '15px' }} />
                    </Grid>
                    <Grid item xs={9} pl={1}>
                      <Typography variant='openSans15' component='div' fontWeight="bold" sx={{color: '#33414B'}}>
                        {focus.name}
                      </Typography>
                      <Typography
                        variant="openSans14"
                        component='div'
                        sx={{ mt: 1, textAlign: 'justify', color: '#33414B' }}
                        dangerouslySetInnerHTML={{ __html: addDotsEllipsis(focus.htmlText, 45) }}
                      />
                    </Grid>
                  </Grid>
                </AStylised>
              );
            })}
          </Box>
        )}
        {!isEmpty(focusData) && openModal && (
          <Dialog id='focus-modal' open={openModal} onClose={handleClose}
                  maxWidth={'md'}
                  aria-labelledby={focusData?.name} aria-describedby={focusData?.htmlText}>
            <Box>
              <ArticleModal data={focusData} handleClose={handleClose} />
            </Box>
          </Dialog>
        )}
      </Grid>
    </Grid>
  );
};

export default Focus;
